// src/components/Popups/practicalExamSlotOccupancy.js
//
// La generarea sloturilor de examen practic, o oră e „ocupată" doar dacă în
// ziua aleasă există deja un slot identic: același sector, aceeași cutie și
// același instructor. Dacă slotul existent e pentru alt sector / altă cutie /
// alt instructor, ora rămâne selectabilă, doar cu un marcaj.

import { normalizePracticalExamSector } from "../../constants/practicalExamCalendar";
import { normalizeGearboxValue } from "./practicalExamInstructorHelpers";

function normalizeTime(value) {
   const match = String(value || "").match(/(\d{1,2}):(\d{2})/);
   if (!match) return "";
   return `${String(Number(match[1])).padStart(2, "0")}:${match[2]}`;
}

function normalizeId(value) {
   return value == null ? "" : String(value).trim();
}

/** Întoarce intrările zilei ca `{ time, sector, gearbox, instructorId }`. */
export function readOccupiedEntriesForDate(occupiedTimesByDate, dateKey) {
   const raw =
      occupiedTimesByDate instanceof Map
         ? occupiedTimesByDate.get(dateKey)
         : occupiedTimesByDate?.[dateKey];
   const list = Array.isArray(raw) ? raw : [];

   return list
      .map((entry) => {
         if (entry && typeof entry === "object") {
            return {
               time: normalizeTime(entry.time ?? entry.timeKey),
               sector: entry.sector ?? "",
               gearbox: entry.gearbox ?? "",
               instructorId: normalizeId(entry.instructorId),
               known: true,
            };
         }
         // compatibilitate: o simplă listă de ore, fără detalii
         return { time: normalizeTime(entry), sector: "", gearbox: "", instructorId: "", known: false };
      })
      .filter((entry) => entry.time);
}

export function isSameSlotConfig(entry, { sector, gearbox, instructorId } = {}) {
   if (!entry?.known) return false;
   const formInstructorId = normalizeId(instructorId);
   if (!formInstructorId || entry.instructorId !== formInstructorId) return false;
   if (
      normalizePracticalExamSector(entry.sector, "") !==
      normalizePracticalExamSector(sector, "")
   ) {
      return false;
   }
   return normalizeGearboxValue(entry.gearbox) === normalizeGearboxValue(gearbox);
}

/**
 * `exact`: ore cu un slot identic (se dezactivează).
 * `elsewhere`: ore cu sloturi doar pentru altă configurație (rămân selectabile).
 */
export function buildPracticalExamTimeOccupancy(entries, config) {
   const exact = new Set();
   const elsewhere = new Set();

   for (const entry of Array.isArray(entries) ? entries : []) {
      if (!entry?.time) continue;
      if (isSameSlotConfig(entry, config)) exact.add(entry.time);
      else elsewhere.add(entry.time);
   }

   for (const time of exact) elsewhere.delete(time);
   return { exact, elsewhere };
}
